export { default } from './useMyInvestmentsData'
